const useIsStandalone = () => {
    return window.navigator.standalone || // iOS Safari
        window.matchMedia('(display-mode: standalone)').matches; // Other browsers
};

export default useIsStandalone;